(function () {
  'use strict';

  var config = Object.assign({
    fadeInDuration: 1500,
    fadeOutDuration: 1000,
    defaultVolume: 0.7,
    showTrackLabel: true,
    rememberState: true
  }, window.MusicPlayerConfig || {});

  /* ---------------------------------------------------------------------
     AUTOPLAY_ON_CONSENT

     Set this to true and accepting the cookie banner starts the music.
     That is how this file shipped, and it is off now for three reasons:

       1. Consent for analytics says nothing about wanting sound. Two
          unrelated choices were glued together.
       2. It overrides the default six lines below, which deliberately
          starts every new visitor muted.
       3. triggerPlay() writes 'false' to localStorage, so one click on
          Accept turns the music on for every page and every future
          visit. There is no way back except finding the speaker icon.

     Everything else about the player is untouched: the header toggle
     works, the fade-in works, and anyone who switched the music on
     still gets it back on their next visit.

     To restore the old behaviour, flip this to true. Nothing else.
     --------------------------------------------------------------------- */
  var AUTOPLAY_ON_CONSENT = false;

  var STORAGE_KEY_MUTED = 'shopify_music_muted';
  var player, toggleBtn, audio, labelEl, labelText;
  var routeMap = {};
  var tagMap = {};
  var isMuted = true;
  var currentTrackUrl = null;
  var fadeTimer = null;

  function normalizeVolume(vol) {
    if (!vol) return config.defaultVolume;
    return vol > 1 ? vol / 10 : vol;
  }

  function getVolumeForCurrentTrack() {
    var track = getCurrentTrack();
    return track ? normalizeVolume(track.volume) : config.defaultVolume;
  }

  function getCurrentTrack() {
    // Eerst kijken of het een productpagina is
    var template = player ? player.dataset.template : '';
    if (template === 'product') {
      var productTags = (player.dataset.productTags || '').split(',');
      for (var i = 0; i < productTags.length; i++) {
        var tag = productTags[i].trim();
        if (tag && tagMap[tag]) {
          return tagMap[tag];
        }
      }
    }
    // Anders route matching
    return matchRoute(window.location.pathname);
  }

  function init() {
    player = document.getElementById('shopify-music-player');
    if (!player) return;

    toggleBtn = document.getElementById('music-player-toggle');
    audio = document.getElementById('music-player-audio');
    labelEl = document.getElementById('music-player-label');
    labelText = labelEl ? labelEl.querySelector('.music-player__label-text') : null;

    try {
      routeMap = JSON.parse(player.dataset.routes || '{}');
    } catch (e) {
      routeMap = {};
    }

    try {
      tagMap = JSON.parse(player.dataset.tags || '{}');
    } catch (e) {
      tagMap = {};
    }

    var savedMuted = localStorage.getItem(STORAGE_KEY_MUTED);
    isMuted = savedMuted === null ? true : savedMuted === 'true';

    var pos = player.dataset.position;
    if (pos) player.setAttribute('data-position', pos);

    toggleBtn.addEventListener('click', handleToggle);
    audio.addEventListener('error', handleAudioError);
    window.addEventListener('popstate', onRouteChange);
    document.addEventListener('shopify:section:load', onRouteChange);
    patchHistoryAPI();

    if (AUTOPLAY_ON_CONSENT) {
      document.addEventListener('visitorConsentCollected', function (e) {
        if (e.detail && e.detail.analyticsAllowed) {
          triggerPlay();
        }
      });
    }

    updatePlayerUI();

    /* Snelheid (31 okt 2026): het mp3-bestand (~3 MB) wordt NIET meer vooraf
       geladen. Voorheen stond hier audio.src + preload='auto', waardoor elke
       bezoeker ook met muziek uit 3 MB downloadde (mobiel LCP 23,5 s).
       Het bestand laadt nu pas bij klik op het muziekicoon (triggerPlay),
       of direct als de bezoeker de muziek eerder zelf heeft aangezet. */
    audio.preload = 'none';

    if (!isMuted) {
      triggerPlay();
    }
  }

  function triggerPlay() {
    var track = getCurrentTrack();
    if (!track || !track.url) return;

    isMuted = false;
    localStorage.setItem(STORAGE_KEY_MUTED, 'false');

    currentTrackUrl = track.url;
    audio.src = track.url;
    audio.loop = track.loop !== false;
    audio.muted = false;
    audio.volume = 0;

    if (config.showTrackLabel && track.label && labelText) {
      showTrackLabel(track.label);
    }

    var p = audio.play();
    if (p !== undefined) {
      p.then(function () {
        fadeIn(audio, normalizeVolume(track.volume));
      }).catch(function () {
        isMuted = true;
        localStorage.setItem(STORAGE_KEY_MUTED, 'true');
      });
    }

    updatePlayerUI();
  }

  function matchRoute(pathname) {
    if (routeMap[pathname]) return routeMap[pathname];
    for (var pattern in routeMap) {
      if (patternMatches(pattern, pathname)) return routeMap[pattern];
    }
    return routeMap['/'] || null;
  }

  function patternMatches(pattern, pathname) {
    var escaped = pattern.replace(/[.+?^${}()|[\]\\]/g, '\\$&').replace(/\*/g, '[^/]+');
    return new RegExp('^' + escaped + '(/.*)?$').test(pathname);
  }

  function detectAndLoadTrack(pathname) {
    var track = getCurrentTrack();
    var newUrl = track ? track.url : null;
    if (newUrl === currentTrackUrl) return;
    if (currentTrackUrl && !audio.paused) {
      fadeOut(audio, function () { loadTrack(newUrl, track); });
    } else {
      loadTrack(newUrl, track);
    }
  }

  function loadTrack(url, trackConfig) {
    if (!url) {
      audio.pause();
      audio.src = '';
      currentTrackUrl = null;
      updatePlayerUI();
      return;
    }

    currentTrackUrl = url;
    audio.src = url;
    audio.loop = trackConfig ? trackConfig.loop !== false : true;
    audio.muted = false;
    audio.volume = 0;

    if (config.showTrackLabel && trackConfig && trackConfig.label && labelText) {
      showTrackLabel(trackConfig.label);
    }

    if (!isMuted) {
      var p = audio.play();
      if (p !== undefined) {
        p.then(function () {
          fadeIn(audio, normalizeVolume(trackConfig ? trackConfig.volume : config.defaultVolume));
        }).catch(function () {
          isMuted = true;
          updatePlayerUI();
        });
      }
    }

    updatePlayerUI();
  }

  function handleToggle() {
    isMuted = !isMuted;
    localStorage.setItem(STORAGE_KEY_MUTED, isMuted.toString());

    if (isMuted) {
      fadeOut(audio, function () { audio.pause(); });
    } else {
      triggerPlay();
    }

    updatePlayerUI();
  }

  function updatePlayerUI() {
    if (!toggleBtn) return;
    var isPlaying = !isMuted && currentTrackUrl && !audio.paused;
    toggleBtn.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
    toggleBtn.setAttribute('aria-label', isMuted ? 'Muziek afspelen' : 'Muziek dempen');
    player.classList.toggle('is-playing', isPlaying);
    player.classList.toggle('is-muted', isMuted);
  }

  function showTrackLabel(label) {
    if (!labelEl || !labelText) return;
    labelText.textContent = label;
    labelEl.classList.add('is-visible');
    setTimeout(function () { labelEl.classList.remove('is-visible'); }, 3000);
  }

  function fadeIn(audioEl, targetVolume) {
    clearInterval(fadeTimer);
    audioEl.muted = false;
    var target = targetVolume || config.defaultVolume;
    var steps = 30;
    var stepTime = config.fadeInDuration / steps;
    var stepSize = target / steps;
    var current = 0;
    audioEl.volume = 0;

    fadeTimer = setInterval(function () {
      current = Math.min(current + stepSize, target);
      audioEl.volume = parseFloat(current.toFixed(3));
      if (current >= target) clearInterval(fadeTimer);
    }, stepTime);
  }

  function fadeOut(audioEl, callback) {
    clearInterval(fadeTimer);
    var steps = 20;
    var stepTime = config.fadeOutDuration / steps;
    var startVolume = audioEl.volume;
    var stepSize = startVolume / steps;
    var current = startVolume;

    fadeTimer = setInterval(function () {
      current = Math.max(current - stepSize, 0);
      audioEl.volume = parseFloat(current.toFixed(3));
      if (current <= 0) {
        clearInterval(fadeTimer);
        audioEl.volume = 0;
        if (callback) callback();
      }
    }, stepTime);
  }

  function onRouteChange() {
    var savedMuted = localStorage.getItem(STORAGE_KEY_MUTED);
    if (savedMuted === 'false') {
      isMuted = false;
      setTimeout(function () {
        detectAndLoadTrack(window.location.pathname);
        if (audio.paused && currentTrackUrl) {
          audio.play().then(function () {
            fadeIn(audio, getVolumeForCurrentTrack());
          }).catch(function () {});
        }
      }, 300);
    }
  }

  function patchHistoryAPI() {
    var orig = history.pushState.bind(history);
    var origR = history.replaceState.bind(history);
    history.pushState = function (s, t, u) { orig(s, t, u); onRouteChange(); };
    history.replaceState = function (s, t, u) { origR(s, t, u); onRouteChange(); };
  }

  function handleAudioError() {
    currentTrackUrl = null;
    updatePlayerUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
